import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  CallOptions,
  ConferencingState,
} from '../../state/conferencing.reducer';
import { Store } from '@ngrx/store';
import { selectInboundCallOptions } from '../../state/conferencing.selectors';

@Component({
  selector: 'cm-accept-call-with-delay',
  templateUrl: './accept-call-with-delay.component.html',
  styleUrls: ['./accept-call-with-delay.component.scss'],
})
export class AcceptCallWithDelayComponent implements OnInit {
  inboundCallOptions$: Observable<CallOptions>;

  constructor(private store$: Store<ConferencingState>) {}

  ngOnInit(): void {
    this.inboundCallOptions$ = this.store$.select(selectInboundCallOptions);
  }
}
